export default __webpack_public_path__ + "static/media/fifth.fc46ab64.jpeg";